<svg
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    width="16"
    fill="none"
    viewBox="0 0 24 24"
>
    <path
        fill="rgb(43, 43, 43)"
        fill-rule="evenodd"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm5.412-13.998-1.414-1.414L12 10.586 8.002 6.588 6.588 8.002 10.586 12l-3.998 3.998 1.414 1.414L12 13.414l3.998 3.998 1.414-1.414L13.414 12l3.998-3.998z"
    />
</svg>
